;(function cartRepriceOnMiniCartOpen() {
  let isRunning = false
  let hasCheckedOnce = false

  async function fetchJson(url, options) {
    const res = await fetch(url, options)
    return await res.json()
  }

  async function getCart() {
    try {
      return await fetchJson('/cart.js')
    } catch (e) {
      console.error('cart reprice: failed to fetch cart', e)
      return null
    }
  }

  async function getProduct(handle) {
    try {
      return await fetchJson(`/products/${handle}.js`)
    } catch (e) {
      console.error('cart reprice: failed to fetch product', handle, e)
      return null
    }
  }

  function getMiniCartSections() {
    const miniCart = document.querySelector('mini-cart')
    try {
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        return miniCart.getSectionsToRender().map((s) => s.id)
      }
    } catch (e) {}
    return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble']
  }

  async function removeLineByKey(lineItemKeyOrVariantId) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // Use line item key when available to target the exact line (preserves property-differentiated lines)
        body: JSON.stringify({ id: String(lineItemKeyOrVariantId), quantity: 0 })
      })
    } catch (e) {
      console.error('cart reprice: failed to remove item', lineItemKeyOrVariantId, e)
    }
  }

  async function addLine(variantId, quantity, properties, sections) {
    try {
      const body = {
        id: String(variantId),
        quantity,
        properties,
        sections,
        sections_url: window.location.pathname
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      return await res.json()
    } catch (e) {
      console.error('cart reprice: failed to add item', variantId, e)
      return null
    }
  }

  function shallowEqualProps(a = {}, b = {}) {
    const aKeys = Object.keys(a || {})
    const bKeys = Object.keys(b || {})
    if (aKeys.length !== bKeys.length) return false
    for (const k of aKeys) {
      if (String(a[k]) !== String(b[k])) return false
    }
    return true
  }

  async function resolveKeyFallback(variantId, properties) {
    try {
      const cart = await getCart()
      if (!cart || !Array.isArray(cart.items)) return null
      const match = cart.items.find((it) => it.variant_id === variantId && shallowEqualProps(it.properties, properties))
      return match ? match.key : null
    } catch (e) {
      return null
    }
  }

  // Strict resolver: only return a key if we can uniquely identify the line
  async function getLineKeyStrict(variantId, properties) {
    const cart = await getCart()
    if (!cart || !Array.isArray(cart.items)) return null
    let candidates = cart.items.filter((it) => it.variant_id === variantId)
    if (properties && Object.keys(properties || {}).length > 0) {
      candidates = candidates.filter((it) => shallowEqualProps(it.properties, properties))
    }
    if (candidates.length === 1) return candidates[0].key
    return null // ambiguous or not found -> do not risk removing wrong item
  }

  async function repriceIfNeeded() {
    if (isRunning || hasCheckedOnce) return
    isRunning = true

    const cart = await getCart()
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      isRunning = false
      hasCheckedOnce = true
      return
    }

    const updates = []
    for (const item of cart.items) {
      const product = await getProduct(item.handle)
      if (!product || !Array.isArray(product.variants)) continue
      const currentVariant = product.variants.find((v) => v.id === item.variant_id)
      if (!currentVariant) continue
      if (currentVariant.price !== item.price) {
        updates.push({
          variantId: item.variant_id,
          quantity: item.quantity,
          properties: item.properties || undefined,
          key: item.key
        })
      }
    }

    if (updates.length === 0) {
      isRunning = false
      hasCheckedOnce = true
      return
    }

    const sections = getMiniCartSections()
    let lastParsedState = null

    for (const u of updates) {
      // Prefer exact key from original cart snapshot
      let removeId = u.key
      // If missing, resolve strictly to avoid deleting wrong item
      if (!removeId) {
        removeId = await getLineKeyStrict(u.variantId, u.properties)
      }
      // As a last non-strict fallback (same props & variant) if strict resolution failed
      if (!removeId) {
        removeId = await resolveKeyFallback(u.variantId, u.properties)
      }

      // If still ambiguous or not found, skip this update to avoid removing the wrong line
      if (!removeId) {
        console.warn('cart reprice: skip removal due to ambiguous line identification', u)
        continue
      }

      await removeLineByKey(removeId)
      const parsed = await addLine(u.variantId, u.quantity, u.properties, sections)
      if (parsed && parsed.sections) lastParsedState = parsed
    }

    try {
      const miniCart = document.querySelector('mini-cart')
      if (miniCart && lastParsedState && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(lastParsedState)
      }
    } catch (e) {
      console.error('cart reprice: failed to render mini-cart', e)
    }

    try {
      const updatedCart = await getCart()
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }))
      if (lastParsedState) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: lastParsedState } }))
      }
    } catch (e) {}

    isRunning = false
    hasCheckedOnce = true
  }

  document.addEventListener('mini-cart:open', repriceIfNeeded)
})()


